import React from 'react';
import Navbar from './Navbar';
import MainSection from './MainSection';
import ElevateSection from './ElevateSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import FeaturesSection from './FeaturesSection';
import Choose from './Choose';
import Work from './Work';
import Testimonial from './Testimonial';
import PlayStoreIcon from './PlayStoreIcon';
import Footer from './Footer';

function HomePage() {
  return (
    <>
      <Navbar />
      <MainSection />
      <ElevateSection />
      <AboutSection />
      <ServicesSection />
      <FeaturesSection />
      <Choose />
      <Work />
      <Testimonial />
      <PlayStoreIcon />
      <Footer />
    </>
  );
}

export default HomePage;